import React from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import { ConfigurationStore } from "stores";

const Header: React.FC = (): JSX.Element => {
  const configuration = React.useContext(ConfigurationStore);
  const { formatMessage: t } = useIntl();
  const href = window.location.href;
  const title = configuration.application.title || "carbando catalog";

  return (
    <>
      <h1 className="aria-hidden">
        {t(
          {
            id: "pages.modelle.title",
            defaultMessage: "Gruppierte Übersicht der verfügbaren Modelle",
          },
          {},
        )}
      </h1>
      <Helmet>
        {configuration.application.inline === false && (
          <>
            <title>{title}</title>
            <meta property="og:title" content={title} />
            <meta property="og:url" content={href} />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content={title} />
          </>
        )}
      </Helmet>
    </>
  );
};

export default Header;
